<template>
    <Teleport to="body">

        <Transition
            @enter="onEnter"
            @after-enter="onAfterEnter"
            name="modal"
        >
            <div
                v-if="showRef"
                ref="modalContainerRef"
                :class="['yps-app cm-app-wrapper modal-mask tailwindcss', { 'items-center' : alignItemsCenterRef == true }, { 'items-start' : alignItemsCenterRef == false }, containerClasses]"
            >
                <div ref="modalRef" :class="modalContainerClass" v-click-outside="event => dismissible && handleOutsideClick(event)">
                    <div class="modal-header">
                        <!-- 
                            Titolo del modal 

                            #openModal Esegue 'open'
                            #closeModal Esegue 'close'
                        -->
                        <slot name="header" :openModal="open" :closeModal="close"></slot>
                    </div>

                    <div class="modal-body">
                        <!-- 
                            Contenuto del modal 

                            #openModal Esegue 'open'
                            #closeModal Esegue 'close'
                        -->
                        <slot name="body" :openModal="open" :closeModal="close"></slot>
                    </div>

                    <div v-if="$slots.footer" class="modal-footer">
                        <!-- 
                            Footer del modal

                            #openModal Esegue 'open'
                            #closeModal Esegue 'close'
                        -->
                        <slot name="footer" :openModal="open" :closeModal="close"></slot>
                    </div>
                </div>
            </div>
        </Transition>

    </Teleport>

</template>

<script setup>
import { useModal } from '@jinkosoft/modal'

const props = defineProps({
    modelValue: Boolean,
    dismissible: { type: Boolean, default: true },
    containerClasses: {
        type: [Array, Object, String],
        default: []
    },
    modalContainerClass: {
        type: [Array, String],
        default: 'modal-container'
    }
})

const emit = defineEmits([
    'update:modelValue',
    'open',
    'close',
    'onAfterEnter',
    'onEnter'
])

const {
    modalContainerRef,
    modalRef,
    showRef,
    alignItemsCenterRef,
    open,
    close,
    onEnter,
    onAfterEnter,
    handleOutsideClick
} = useModal(props, emit)

defineExpose({ open, close })
</script>

<style lang="scss">

.overflow-hidden {
  overflow: hidden;
}

.modal-mask {
  overflow: auto;
  position: fixed;
  z-index: 100001;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(15, 23, 42, 0.55);
  transition: opacity 0.3s ease;
  backdrop-filter: blur(8px);

  @apply flex justify-center;
}

.modal-container {
  margin: auto;
  background-color: #fff;
  box-shadow: 0 24px 80px rgba(15, 23, 42, 0.22);
  transition: all 0.3s ease;
  border-radius: 24px;
  border: 1px solid rgba(226, 232, 240, 0.9);
  @apply mb-[64px] mt-[64px] h-fit w-[92%] py-5 px-4 md:w-[60%] md:px-6 #{!important};
}

.modal-header h3 {
  margin-top: 0;
  color: rgb(15 23 42);
}

.modal-body {
  margin: 16px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
